import { render, staticRenderFns } from "./SessionProfile.vue?vue&type=template&id=25b5f1c2&scoped=true&lang=pug"
import script from "./SessionProfile.vue?vue&type=script&lang=js"
export * from "./SessionProfile.vue?vue&type=script&lang=js"
import style0 from "./SessionProfile.vue?vue&type=style&index=0&id=25b5f1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5f1c2",
  null
  
)

export default component.exports